// Trilingual dictionary (FR / EN / DE)
export const translations = {
  fr: {
    appName: "Estimateur Pension Luxembourg",
    tagline: "Calculez votre pension du secteur privé — brut, déductions, et net après impôts.",
    cta: "Lancer le calcul",
    nav: { calculator: "Calculateur", dashboard: "Mes scénarios", login: "Connexion", register: "Inscription", logout: "Déconnexion", blog: "Guides", frontaliers: "Frontaliers", share: "Partager", shareCopied: "Lien copié", legal: "Mentions légales", privacy: "Confidentialité" },
    form: {
      method: "Méthode de calcul",
      cnap: "CNAP (officielle simplifiée)",
      simple: "Approximation simple",
      personal: "Informations personnelles",
      career: "Carrière",
      salary: "Salaire",
      family: "Situation familiale",
      currentAge: "Âge actuel",
      retirementAge: "Âge de la retraite",
      careerStartAge: "Âge de début d'emploi salarié",
      careerStartHint: "Âge auquel vous avez commencé à cotiser comme salarié",
      educationYears: "Années d'études supérieures",
      educationYearsHint: "Études post-secondaires (max 10 ans, créditées comme périodes complémentaires)",
      monthlySalary: "Salaire brut mensuel ACTUEL (€)",
      salaryHint: "Indiquez votre salaire d'aujourd'hui, pas votre salaire de début de carrière.",
      pastGrowth: "Croissance passée du salaire (%/an)",
      pastGrowthHint: "De votre début de carrière jusqu'à aujourd'hui",
      futureGrowth: "Croissance future estimée (%/an)",
      futureGrowthHint: "D'aujourd'hui jusqu'à la retraite",
      taxClass: "Classe d'impôt",
      children: "Enfants à charge",
      class1: "Classe 1 (célibataire)",
      class1a: "Classe 1a (parent isolé / veuf)",
      class2: "Classe 2 (marié / pacsé)",
      calculate: "Calculer",
      save: "Sauvegarder ce scénario",
      label: "Libellé du scénario",
      labelPlaceholder: "Ex : Plan A — retraite à 62 ans",
    },
    result: {
      title: "Résultat",
      gross: "Pension brute mensuelle",
      health: "Assurance maladie (2,80%)",
      dependency: "Assurance dépendance (1,40%)",
      tax: "Impôt sur le revenu",
      net: "Pension nette mensuelle",
      yearsOfCareer: "Années de carrière",
      avgCareer: "Salaire moyen carrière",
      replacement: "Taux de remplacement",
      forfait: "Majoration forfaitaire",
      proportional: "Majoration proportionnelle",
      breakdown: "Détail du calcul",
      simple: "Vue simple",
      detailed: "Vue détaillée",
      perMonth: "/ mois",
      perYear: "/ an",
      saved: "Scénario enregistré",
      loginToSave: "Connectez-vous pour sauvegarder",
    },
    dashboard: {
      title: "Mes scénarios",
      empty: "Aucun scénario sauvegardé. Lancez un calcul puis enregistrez-le.",
      newScenario: "Nouveau scénario",
      delete: "Supprimer",
      created: "Créé le",
      compareLabel: "Comparaison",
    },
    auth: {
      loginTitle: "Connexion",
      registerTitle: "Inscription",
      email: "Adresse email",
      password: "Mot de passe",
      name: "Nom",
      submit: "Valider",
      switchToRegister: "Pas de compte ? S'inscrire",
      switchToLogin: "Déjà inscrit ? Se connecter",
    },
    footer: "Outil informatif — pas une décision officielle CNAP.",
  },
  en: {
    appName: "Luxembourg Pension Estimator",
    tagline: "Compute your private-sector pension — gross, deductions, and net after taxes.",
    cta: "Run estimation",
    nav: { calculator: "Calculator", dashboard: "My scenarios", login: "Sign in", register: "Sign up", logout: "Sign out", blog: "Guides", frontaliers: "Cross-border", share: "Share", shareCopied: "Link copied", legal: "Legal notice", privacy: "Privacy" },
    form: {
      method: "Calculation method",
      cnap: "CNAP (official simplified)",
      simple: "Simple approximation",
      personal: "Personal info",
      career: "Career",
      salary: "Salary",
      family: "Family status",
      currentAge: "Current age",
      retirementAge: "Retirement age",
      careerStartAge: "Age started as paid employee",
      careerStartHint: "Age you began contributing as a salaried worker",
      educationYears: "Years of higher education",
      educationYearsHint: "Post-secondary studies (max 10 years, credited as complementary periods)",
      monthlySalary: "CURRENT gross monthly salary (€)",
      salaryHint: "Enter your salary today, not your starting salary.",
      pastGrowth: "Past salary growth (%/year)",
      pastGrowthHint: "From career start until today",
      futureGrowth: "Estimated future growth (%/year)",
      futureGrowthHint: "From today until retirement",
      taxClass: "Tax class",
      children: "Dependent children",
      class1: "Class 1 (single)",
      class1a: "Class 1a (single parent / widow)",
      class2: "Class 2 (married / partnered)",
      calculate: "Calculate",
      save: "Save this scenario",
      label: "Scenario label",
      labelPlaceholder: "e.g. Plan A — retire at 62",
    },
    result: {
      title: "Result",
      gross: "Gross monthly pension",
      health: "Health insurance (2.80%)",
      dependency: "Dependency insurance (1.40%)",
      tax: "Income tax",
      net: "Net monthly pension",
      yearsOfCareer: "Years of career",
      avgCareer: "Avg career salary",
      replacement: "Replacement rate",
      forfait: "Flat increment",
      proportional: "Proportional increment",
      breakdown: "Calculation details",
      simple: "Simple view",
      detailed: "Detailed view",
      perMonth: "/ month",
      perYear: "/ year",
      saved: "Scenario saved",
      loginToSave: "Sign in to save",
    },
    dashboard: {
      title: "My scenarios",
      empty: "No saved scenarios. Run a calculation and save it.",
      newScenario: "New scenario",
      delete: "Delete",
      created: "Created",
      compareLabel: "Comparison",
    },
    auth: {
      loginTitle: "Sign in",
      registerTitle: "Sign up",
      email: "Email address",
      password: "Password",
      name: "Name",
      submit: "Submit",
      switchToRegister: "No account? Sign up",
      switchToLogin: "Already have an account? Sign in",
    },
    footer: "Informational tool — not an official CNAP decision.",
  },
  de: {
    appName: "Luxemburger Rentenrechner",
    tagline: "Berechnen Sie Ihre Rente im Privatsektor — Brutto, Abzüge und Netto nach Steuern.",
    cta: "Berechnung starten",
    nav: { calculator: "Rechner", dashboard: "Meine Szenarien", login: "Anmelden", register: "Registrieren", logout: "Abmelden", blog: "Leitfäden", frontaliers: "Grenzgänger", share: "Teilen", shareCopied: "Link kopiert", legal: "Impressum", privacy: "Datenschutz" },
    form: {
      method: "Berechnungsmethode",
      cnap: "CNAP (offiziell vereinfacht)",
      simple: "Einfache Näherung",
      personal: "Persönliche Daten",
      career: "Karriere",
      salary: "Gehalt",
      family: "Familienstand",
      currentAge: "Aktuelles Alter",
      retirementAge: "Renteneintrittsalter",
      careerStartAge: "Beginn des Angestelltenverhältnisses",
      careerStartHint: "Alter, in dem Sie als Arbeitnehmer Beiträge zu zahlen begannen",
      educationYears: "Jahre Hochschulbildung",
      educationYearsHint: "Studienjahre nach dem Sekundarschulabschluss (max. 10, als Ergänzungszeiten angerechnet)",
      monthlySalary: "AKTUELLES Bruttomonatsgehalt (€)",
      salaryHint: "Geben Sie Ihr heutiges Gehalt ein, nicht Ihr Anfangsgehalt.",
      pastGrowth: "Bisheriges Gehaltswachstum (%/Jahr)",
      pastGrowthHint: "Vom Karrierebeginn bis heute",
      futureGrowth: "Geschätztes künftiges Wachstum (%/Jahr)",
      futureGrowthHint: "Von heute bis zur Rente",
      taxClass: "Steuerklasse",
      children: "Unterhaltsberechtigte Kinder",
      class1: "Klasse 1 (alleinstehend)",
      class1a: "Klasse 1a (alleinerziehend / verwitwet)",
      class2: "Klasse 2 (verheiratet / Partnerschaft)",
      calculate: "Berechnen",
      save: "Szenario speichern",
      label: "Szenario-Bezeichnung",
      labelPlaceholder: "z.B. Plan A — Rente mit 62",
    },
    result: {
      title: "Ergebnis",
      gross: "Brutto-Monatsrente",
      health: "Krankenversicherung (2,80%)",
      dependency: "Pflegeversicherung (1,40%)",
      tax: "Einkommensteuer",
      net: "Netto-Monatsrente",
      yearsOfCareer: "Berufsjahre",
      avgCareer: "Durchschn. Karrieregehalt",
      replacement: "Ersatzquote",
      forfait: "Pauschalbestandteil",
      proportional: "Proportionalbestandteil",
      breakdown: "Berechnungsdetails",
      simple: "Einfache Ansicht",
      detailed: "Detailansicht",
      perMonth: "/ Monat",
      perYear: "/ Jahr",
      saved: "Szenario gespeichert",
      loginToSave: "Zum Speichern anmelden",
    },
    dashboard: {
      title: "Meine Szenarien",
      empty: "Keine gespeicherten Szenarien. Berechnung durchführen und speichern.",
      newScenario: "Neues Szenario",
      delete: "Löschen",
      created: "Erstellt am",
      compareLabel: "Vergleich",
    },
    auth: {
      loginTitle: "Anmelden",
      registerTitle: "Registrieren",
      email: "E-Mail-Adresse",
      password: "Passwort",
      name: "Name",
      submit: "Bestätigen",
      switchToRegister: "Kein Konto? Registrieren",
      switchToLogin: "Bereits registriert? Anmelden",
    },
    footer: "Informationswerkzeug — keine offizielle CNAP-Entscheidung.",
  },
};
